import React from 'react';
import { SelectBox as SelectBoxJS } from '../selectbox';

export interface SelectBoxProps {
  name?: string;
  label?: string;
  placeholder?: string;

  options?: any[];
  value?: any;
  valueKey?: string;   
  labelKey?: string;  

  clearable?: boolean;
  searchable?: boolean;
  multi?: boolean;
  disabled?: boolean;
  isLoading?: boolean;
  openOnFocus?: boolean;

  width?: string | number;
  menuListStyle?: Record<string, any>;
  styles?: Record<string, any>;
  isPrimaryMaterial?: boolean;
  limitOptions?: number;
  menuPortalTarget?: HTMLElement | null;

  onChange?: (value: any) => void;
  'data-testid'?: string;
}

export const SelectBox: React.FC<SelectBoxProps> = (props) => {
  return <SelectBoxJS {...(props as any)} />;
};
